import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-value-setter",
  templateUrl: "./value-setter.component.html",
  styleUrls: ["./value-setter.component.scss"],
})
export class ValueSetterComponent implements OnInit {
  @Input() value: number = 0;
  @Input() label: string = "";
  @Input() minValue: number = 0;
  @Input() maxValue: number = 10000;
  @Output() onIncrement = new EventEmitter<any>();
  @Output() onDecrement = new EventEmitter<any>();
  @Output() onInputValue = new EventEmitter<any>();
  public disableInc: boolean = false;
  public disableDec: boolean = false;

  constructor() {}

  ngOnInit(): void {
  }

  incrementVal(event: any) {
    if (!this.disableInc) {
      this.value >= this.maxValue
        ? (this.disableInc = true)
        : (this.disableInc = false);
      this.value <= this.minValue
        ? (this.disableDec = true)
        : (this.disableDec = false);
      this.onIncrement.emit();
    }
  }
  decrementVal(event: any) {
    // if (!this.disableDec) {
      this.value >= this.maxValue
        ? (this.disableInc = true)
        : (this.disableInc = false);
      this.value <= this.minValue
        ? (this.disableDec = true)
        : (this.disableDec = false);
      this.onDecrement.emit();
    // }
  }
  inputVal(event: any, value: any) {
    const val=value.replace(/\D/g,'')
    let min = Math.round(this.minValue);
    let max = this.maxValue;
    if (val < min) {
      event.target.value = min;
      this.onInputValue.emit(min);
    } else if (val > max) {
      event.target.value = max;
      this.onInputValue.emit(max);
    } else {
      this.onInputValue.emit(val);
    }
    this.value >= this.maxValue
      ? (this.disableInc = true)
      : (this.disableInc = false);
    this.value <= min ? (this.disableDec = true) : (this.disableDec = false);
  }
}